import styled, { keyframes } from 'styled-components'
import { devices } from '../../../../utils/styledComponentHelpers'

export const LeadGenCrossContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: var(--color-white);
  padding: 10px;
`

export const StyledImage = styled.img`
  height: 40px;
  width: 40px;
  cursor: pointer;
`

export const PrivacyStatements = styled.div`
  font-size: var(--caption-mobile-font-size);
  padding:0px 15px;
  margin-bottom: 10px;
`

export const FormFieldsDiv = styled.div`
`

export const LeadGenFormContainer = styled.div`
  padding: 0px 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
`

export const LeadGenFormDiv = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`

export const H4Text = styled.h4`
  color: var(--color-dark-focus-blue);
  margin-bottom: 1rem;
  font-family: var(--font-family-bold) !important;
`

export const Desc = styled.p`
  color: var(--color-rich-black);
  text-align: center;
  opacity: 62%;
`

export const ButtonsDiv = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  padding: 20px 15px 25px 15px;
`

export const FieldAndServerErrorContainer = styled.div`
  margin: 0px 15px 15px 15px;
`

export const FieldContainer = styled.div`
  margin-bottom: 5px;
`

export const ErrorContainer = styled.div`
  margin-top: 0.4rem;
  border: ${({ $serverErrorMessages }) => {
    return $serverErrorMessages && $serverErrorMessages.length ? '1px solid var(--color-validation-red)' : 'none';
  }};
  background-color: rgba(199, 0, 0, 0.1019607843);
  color: var(--color-validation-red);
  box-shadow: none;
  max-width: 300px;
  padding: 10px;
  margin-bottom: 20px;
`

export const ErrorText = styled.div`
  font-size: var(--caption-mobile-font-size);
  color: var(--color-validation-red);  
  letter-spacing: 0px;
  margin-bottom: 1rem;
`

export const Privacy1stdiv = styled.div`
  a {
    text-decoration: underline;
  }
`

export const Privacy2nddiv = styled.div`
`

const l2 = keyframes`
  to{transform: rotate(1turn)}
`
export const SpinnerContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.6rem 0px 4.5rem 0px;
`
export const SpinnerDiv = styled.div`
  width: 40px;
  height: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid #EDEDED;
  border-right-color: #24358D;
  border-top-color: #24358D;
  border-bottom-color: #24358D;
  animation: ${l2} 1s infinite linear;
`

export const SuccessPopupContainer = styled.div`
  padding: 20px 10px 40px 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const SuccessPopupTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 5rem;
  padding: 0 20px;
`

export const SuccessPopupH4Text = styled.h4`
  color: var(--color-dark-focus-blue);
  margin-bottom: 1.6rem;
  font-family: var(--font-family-bold) !important;
`

export const SuccessPopupButtonsDiv = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  padding: 0 20px;
`
